export default {"src":"/_next/static/media/fg.05df0abd.svg","height":52,"width":56,"blurWidth":0,"blurHeight":0};